import * as ActionTypes from '../components/actions/types';
import { EVENT_TEAM_SIDEBAR_TABS } from '../components/events/constant';

const initialState = {
  eventId: -1,
  eventSlug: '',
  eventTeamSidebarTab: EVENT_TEAM_SIDEBAR_TABS.TEAM_TAB,
  eventDetailTeams: {
    contentView: '',
    sortMethod: '',
    filterVal: ''
  },
  eventUserInfo: {
    section: '',
    isParticipant: false,
    isTeamMember: false,
    isTeamHost: false
  },
  eventsTemperailyAccessible: {}
};

function viewReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_EVENT_TEMPORARILY_ACCESSIBLE: {
      return {
        ...state,
        eventsTemperailyAccessible: {
          ...state.eventsTemperailyAccessible,
          [action.payload.eventSlug]: action.payload.status
        }
      };
    }
    case ActionTypes.RESET_VIEW: {
      return initialState;
    }
    case ActionTypes.SET_EVENT_TEAM_SIDEBAR_TAB: {
      return {
        ...state,
        eventTeamSidebarTab: action.payload
      };
    }
    case ActionTypes.SET_EVENT_DETAIL_TEAMS_CONTENT_VIEW: {
      return {
        ...state,
        eventDetailTeams: {
          ...state.eventDetailTeams,
          contentView: action.payload
        }
      };
    }
    case ActionTypes.USER_LOGOUT: {
      return initialState;
    }
    case ActionTypes.SET_SORT_METHOD: {
      return {
        ...state,
        eventDetailTeams: {
          ...state.eventDetailTeams,
          sortMethod: action.payload
        }
      };
    }
    case ActionTypes.SET_FILTER_VAL: {
      return {
        ...state,
        eventDetailTeams: {
          ...state.eventDetailTeams,
          filterVal: action.payload
        }
      };
    }
    case ActionTypes.FETCH_SINGLE_EVENT: {
      return {
        ...state,
        eventId: action.payload.event.id,
        eventSlug: action.payload.event.slug,
        eventUserInfo: {
          ...state.eventUserInfo,
          ...action.payload.userInfo
        }
      };
    }
    case ActionTypes.UPDATE_EVENT_USER_INFO: {
      return {
        ...state,
        eventUserInfo: {
          ...state.eventUserInfo,
          ...action.payload
        }
      };
    }
    default: {
      return state;
    }
  }
}

export default viewReducer;



// WEBPACK FOOTER //
// ./src/reducers/view.js